import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ParkbaseStorageService } from 'src/app/@shared/services/parkbaseStorage.service';
import { Definition, FilterSet } from 'src/app/@core/domain/interfaces/definition.interface';
import { DefinitionsApiService } from 'src/app/@core/api/definitions-api.service';
import { NbDateService } from '@nebular/theme';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { TrackingService } from 'src/app/@shared/services/tracking.service';
import { LogService } from '../../../../../@core';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.guess();

@Component({
  selector: 'app-notifications-filter',
  templateUrl: './notifications-filter.component.html',
  styleUrls: ['./notifications-filter.component.scss'],
})
export class NotificationsFilterComponent implements OnInit {
  @Input()
  searchTerm!: string;

  @ViewChild('item') accordion!: any;

  @Output()
  filtersSelectedOutput = new EventEmitter<FilterSet>();

  filterSet: FilterSet;
  filtering = false;
  filterSelectedCount = 0;

  min!: Date;
  max!: Date;
  filterFrom!: Date;
  // defaultFromDate = dayjs().set('hour', 23).set('minute', 59).set('second', 59).subtract(29, 'day');
  defaultFromDate = dayjs().subtract(1, 'day');

  constructor(
    private parkbaseStorageService: ParkbaseStorageService,
    private definitionsApiService: DefinitionsApiService,
    protected dateService: NbDateService<Date>,
    private trackingService: TrackingService,
    private logger: LogService
  ) {
    this.filterSet = this.parkbaseStorageService.retrieveFilterSet();
  }

  ngOnInit(): void {
    if (this.parkbaseStorageService.getStorage().has('PBDefinitionLists')) {
      this.fetchDefinitions();
    } else {
      this.definitionsApiService.loadDefinitions().subscribe((data) => {
        if (data) {
          this.fetchDefinitions();
        }
      });
    }
    this.min = this.dateService.addMonth(this.dateService.today(), -1);
    this.max = this.dateService.today();
    this.filterFrom = this.defaultFromDate.toDate();
  }

  fetchDefinitions(): void {
    let notificationTypes: Definition[] = this.parkbaseStorageService.retrieveDefinitionList(4);
    if (notificationTypes.length === 0) {
      notificationTypes = this.parkbaseStorageService.retrieveDefinitionList(4);
    }
    this.filterSet = this.parkbaseStorageService.prepareNotificationTypeFilterSet(
      dayjs(this.filterFrom),
      notificationTypes
    );
    this.countFiltersSelected();
  }

  showFilterActions(): void {}

  countFiltersSelected(): void {
    this.filterSelectedCount = 0;
    this.filterSet.filtersSelected.forEach((e) => {
      if (e.checked) {
        this.filterSelectedCount += 1;
      }
    });
  }

  clearFilterform(): void {
    this.searchTerm = '';
    this.filtering = false;
    this.filterFrom = this.defaultFromDate.toDate();
    this.filterSet.filtersSelected.forEach((e) => {
      e.checked = false;
    });
    this.filterSelectedCount = 0;
  }

  toggle(checked: boolean, id: number): void {
    this.filterSet.filtersSelected.forEach((e) => {
      if (e.id === id) {
        e.checked = checked;
        if (checked) {
          this.filterSelectedCount += 1;
        } else {
          this.filterSelectedCount -= 1;
        }
      }
    });
  }

  saveFilterSet(): void {
    this.filterSet.from = dayjs(this.filterFrom);
    this.parkbaseStorageService.saveNotificationTypeFilterSet(this.filterSet);
    this.accordion.toggle();
    const filterSet = {
      from: dayjs(this.filterFrom),
      filtersSelected: this.filterSet.filtersSelected.filter((f) => f.checked),
    };
    this.filtersSelectedOutput.emit(filterSet);
    this.trackingService.eventEmitter('notificationFilter', 'action', 'saveFilterSet', '', 0);
    this.logger.info('Notification filter set saved');
  }

  resetFilterSet(): void {
    this.clearFilterform();
    this.parkbaseStorageService.saveNotificationTypeFilterSet(this.filterSet);
    this.trackingService.eventEmitter('notificationFilter', 'action', 'resetFilterSet', '', 0);
    this.logger.info('Notification filter set reset');
  }

  applyFilterSet(): void {
    const filterSet = {
      from: dayjs(this.filterFrom),
      filtersSelected: this.filterSet.filtersSelected.filter((f) => f.checked),
    };
    this.filtersSelectedOutput.emit(filterSet);
    this.countFiltersSelected();
    this.parkbaseStorageService.saveNotificationTypeFilterSet(this.filterSet);
    this.trackingService.eventEmitter('notificationFilter', 'action', 'applyFilterSet', '', 0);
    this.logger.info('Notification filter set applied');
  }

  cancelFilterSet(): void {
    this.clearFilterform();
    this.filterSet = this.parkbaseStorageService.retrieveFilterSet();
    const filterSet = {
      from: dayjs(this.filterFrom),
      filtersSelected: this.filterSet.filtersSelected.filter((f) => f.checked),
    };
    this.filtersSelectedOutput.emit(filterSet);
    this.countFiltersSelected();
    this.accordion.toggle();
    this.trackingService.eventEmitter('notificationFilter', 'action', 'cancelFilterSet', '', 0);
    this.logger.info('Notification filter set canceled');
  }
}
